import { coverManagerConstants } from '@constants/cover-manager';

const initialState = {
    data: [],
    loading: true,
    error: '',
};

export function coverManager(state = initialState, action) {
    switch (action.type) {
        case coverManagerConstants.COVER_MANAGER_RESTAURANTS_REQUEST:
            return { ...state, loading: true, error: '' };
        case coverManagerConstants.COVER_MANAGER_RESTAURANTS_SUCCESS:
            return { ...state, loading: false, data: action.data, error: '' };
        case coverManagerConstants.COVER_MANAGER_RESTAURANTS_ERROR:
            return { ...state, loading: false, error: action.message };
        case coverManagerConstants.COVER_MANAGER_RESTAURANTS_RESET:
            return { ...state, data: [] };
        default:
            return state;
    }
}
